import React, { useEffect } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';

const LeadGenerateTable = () => {
    useEffect(() => {
        const table = $('#dataTable').DataTable({
            pageLength: 10,
        });
        return () => {
            table.destroy(true);
        };
    }, []);
    return (
        <div className="card basic-data-table ">
            <div className="card-header">
                <h5 className="card-title mb-0">Leads Details</h5>
            </div>
            <div className="card-body">
                <table
                    className="table bordered-table mb-0 table small "
                    id="dataTable"
                    data-page-length={10}
                >
                    <thead>
                        <tr>
                            <th scope="col">Sr.#</th>
                            <th scope="col">Center Name</th>
                            <th scope="col">Total Leads</th>
                            <th scope="col">New	</th>
                            <th scope="col">Scheduled</th>
                            <th scope="col">Follow Up</th>
                            <th scope="col">Converted</th>
                            <th scope="col">Transferred</th>


                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>01</td>
                            <td><Link to="#" className="text-primary-600">SHC TN Mambalam</Link></td>
                            <td>1200</td>
                            <td>10</td>
                            <td>2</td>
                            <td>98</td>
                            <td>40</td>
                            <td>450</td>
                        </tr>
                        <tr>
                            <td>02</td>
                            <td><Link to="#" className="text-primary-600">SHC KA Banasankari</Link></td>
                            <td>1400</td>
                            <td>12</td>
                            <td>3</td>
                            <td>110</td>
                            <td>38</td>
                            <td>490</td>
                        </tr>
                        <tr>
                            <td>03</td>
                            <td><Link to="#" className="text-primary-600">SHC MH Dadar</Link></td>
                            <td>1600</td>
                            <td>15</td>
                            <td>4</td>
                            <td>130</td>
                            <td>35</td>
                            <td>520</td>
                        </tr>
                        <tr>
                            <td>04</td>
                            <td><Link to="#" className="text-primary-600">SHC KA Kundalahalli</Link></td>
                            <td>1700</td>
                            <td>14</td>
                            <td>2</td>
                            <td>140</td>
                            <td>42</td>
                            <td>530</td>
                        </tr>
                        <tr>
                            <td>05</td>
                            <td><Link to="#" className="text-primary-600">SHC MH Virar</Link></td>
                            <td>1500</td>
                            <td>11</td>
                            <td>1</td>
                            <td>120</td>
                            <td>36</td>
                            <td>510</td>
                        </tr>
                        <tr>
                            <td>06</td>
                            <td><Link to="#" className="text-primary-600">SHC MH Andheri</Link></td>
                            <td>1800</td>
                            <td>18</td>
                            <td>5</td>
                            <td>150</td>
                            <td>39</td>
                            <td>560</td>
                        </tr>
                        <tr>
                            <td>07</td>
                            <td><Link to="#" className="text-primary-600">SHC MH Vashi</Link></td>
                            <td>1900</td>
                            <td>20</td>
                            <td>6</td>
                            <td>160</td>
                            <td>37</td>
                            <td>580</td>
                        </tr>
                        <tr>
                            <td>08</td>
                            <td><Link to="#" className="text-primary-600">SHC TN Adyar</Link></td>
                            <td>1100</td>
                            <td>9</td>
                            <td>2</td>
                            <td>95</td>
                            <td>41</td>
                            <td>430</td>
                        </tr>
                        <tr>
                            <td>09</td>
                            <td><Link to="#" className="text-primary-600">SHC KA Indiranagar</Link></td>
                            <td>1350</td>
                            <td>13</td>
                            <td>3</td>
                            <td>115</td>
                            <td>34</td>
                            <td>470</td>
                        </tr>
                        <tr>
                            <td>10</td>
                            <td><Link to="#" className="text-primary-600">SHC MH Bandra</Link></td>
                            <td>1650</td>
                            <td>16</td>
                            <td>4</td>
                            <td>145</td>
                            <td>43</td>
                            <td>540</td>
                        </tr>
                        <tr>
                            <td>11</td>
                            <td><Link to="#" className="text-primary-600">SHC TN Anna Nagar</Link></td>
                            <td>1250</td>
                            <td>10</td>
                            <td>2</td>
                            <td>100</td>
                            <td>38</td>
                            <td>460</td>
                        </tr>
                        <tr>
                            <td>12</td>
                            <td><Link to="#" className="text-primary-600">SHC KA Jayanagar</Link></td>
                            <td>1450</td>
                            <td>14</td>
                            <td>3</td>
                            <td>118</td>
                            <td>35</td>
                            <td>480</td>
                        </tr>
                        <tr>
                            <td>13</td>
                            <td><Link to="#" className="text-primary-600">SHC MH Ghatkopar</Link></td>
                            <td>1750</td>
                            <td>17</td>
                            <td>4</td>
                            <td>135</td>
                            <td>40</td>
                            <td>550</td>
                        </tr>
                        <tr>
                            <td>14</td>
                            <td><Link to="#" className="text-primary-600">SHC TN Velachery</Link></td>
                            <td>1150</td>
                            <td>8</td>
                            <td>2</td>
                            <td>90</td>
                            <td>42</td>
                            <td>420</td>
                        </tr>
                        <tr>
                            <td>15</td>
                            <td><Link to="#" className="text-primary-600">SHC KA Whitefield</Link></td>
                            <td>1300</td>
                            <td>12</td>
                            <td>3</td>
                            <td>112</td>
                            <td>39</td>
                            <td>460</td>
                        </tr>
                    </tbody>

                </table>
            </div>
        </div>

    )
}

export default LeadGenerateTable